import React from "react";

const NotificationContext = React.createContext();
NotificationContext.displayName = "NotificationContext";

export default NotificationContext;